export default "__VITE_ASSET__CNdvSW78__"